<template>
    <div class="toast-wrapper" v-if="toastData">
        <p class="toast-inner">
            {{toastData.text}}
        </p>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'Toast',
    computed: {
        ...mapState(['lang', 'toastData'])
    }
}
</script>

<style lang="scss" scoped>
    .toast-wrapper{
        position: fixed;
        bottom: 25vw;
        left: 0;
        text-align: center;
        width: 100%;
        padding: 0 10vw;
        box-sizing: border-box;
        z-index: 6;
        animation: fadeScale 0.5s linear both;
    }
    .toast-inner{
        display: inline-block;
        font-size: 3.5vw;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        line-height: 1.5;
        padding: 1.5vw 4vw;
        border-radius: 5vw;
    }

    @keyframes fadeScale{
        0%{
            opacity:0;
            transform:scale(0);
        }
        to{
            opacity:1;
            transform:scale(1);
        }
    }
</style>
